import { formsV2BuilderRoutes } from '@pbk-web/main-forms-v2-builder';
import { insightSpaceRoutes } from '@pbk-web/main-insight-space';
import { trainingRoutes } from '@pbk-web/main-training';
import type { RouteWithTitle } from '@pbk-web/types';

import adminRoutes from './admin.routes';
import clientRoutes from './client.routes';
import devRoutes from './dev.routes';
import labsRoutes from './labs.routes';
import publicRoutes from './public.routes';
import workspaceRoutes from './workspace.routes';

const routes: RouteWithTitle[] = [
  ...workspaceRoutes,
  ...clientRoutes,
  ...adminRoutes,
  ...publicRoutes,
  ...insightSpaceRoutes,
  ...formsV2BuilderRoutes,
  ...trainingRoutes,
  ...devRoutes,
  ...labsRoutes,
];

export default routes;
